export const realtorData = {
  email: 'jmaldonado@unne.cl',
  phone:'56932476703'
  // email: 'contacto@accionpanal.com',
};

export const footerData = {
  email: 'jmaldonado@unne.cl',
  phone:'932476703',
  wsp:'932476703',
}
